import * as React from "react";

const CarosulArrow: React.FC = () => {
    return (
        <svg width="13px" height="25px" viewBox="0 0 13 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icons/CarosulArrow</title>
    <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Product-Detail_Default" transform="translate(-674.000000, -492.000000)" stroke="#33333A">
            <g id="Group-5" transform="translate(160.500000, 220.000000)">
                <polyline id="Icons/CarosulArrow" transform="translate(520.000000, 284.500000) rotate(-90.000000) translate(-520.000000, -284.500000) " points="508 278.5 520 290.5 532 278.5"></polyline>
            </g>
        </g>
    </g>
</svg>
    );
};

export default React.memo(CarosulArrow);
